import { create } from 'zustand'

export type T_Screen = 'start' | 'list'
export type T_Tab = 'shortlist' | 'systems' | 'cases'

type NavigationState = {
  screen: T_Screen
  tab: T_Tab
  navigateScreen: (screen: T_Screen) => void
  navigateTab: (tab: T_Tab) => void

  filterPanelOpen: boolean
  setFilterPanelOpen: (isOpen: boolean) => void

  wizardOpen: boolean
  setWizardOpen: (isOpen: boolean) => void

  systemModalOpen: boolean
  setSystemModalOpen: (isOpen: boolean) => void

  selectedSystemPostId?: number
  setSelectedSystemPostId: (id: number | undefined) => void

  caseModalOpen: boolean
  setCaseModalOpen: (isOpen: boolean) => void

  selectedCasePostId?: number
  setSelectedCasePostId: (id: number | undefined) => void
}

export const useNavigationStore = create<NavigationState>((set) => ({
  screen: 'start',
  tab: 'systems',
  navigateScreen: (screen) => set({ screen: screen }),
  navigateTab: (tab) => set({ tab: tab }),

  filterPanelOpen: false,
  setFilterPanelOpen: (isOpen) => set({ filterPanelOpen: isOpen }),
  wizardOpen: false,
  setWizardOpen: (isOpen) => set({ wizardOpen: isOpen }),

  systemModalOpen: false,
  setSystemModalOpen: (isOpen) => set({ systemModalOpen: isOpen }),

  selectedSystemPostId: undefined,
  setSelectedSystemPostId: (id) => set({ selectedSystemPostId: id }),

  caseModalOpen: false,
  setCaseModalOpen: (isOpen) => set({ caseModalOpen: isOpen }),

  selectedCasePostId: undefined,
  setSelectedCasePostId: (id) => set({ selectedCasePostId: id }),
}))
